export default "__VITE_ASSET__DCmkhwQR__"